export default __webpack_public_path__ + "f0fa4613fe01b7b7f2fb02d44f265655.png";